import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'

import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Modal } from 'components/shared/Modal/Modal'

import styles from './DeleteResourceModal.module.scss'

type DeleteResourceModalProps = Pick<
  React.ComponentProps<typeof Modal>,
  'className' | 'title' | 'onCancel' | 'onClose' | 'onConfirm' | 'isOpen'
> & {
  alert: React.ReactNode
  message?: React.ReactNode
  confirmLabel?: React.ReactNode
}

export const DeleteResourceModal = ({
  alert,
  className = undefined,
  message,
  title,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
  confirmLabel = undefined,
}: DeleteResourceModalProps) => (
  <Modal
    className={cx(styles.modal, className)}
    cancelLabel={t`Go back`}
    confirmLabel={confirmLabel || t`Delete`}
    {...{ title, onCancel, onClose, onConfirm, isOpen }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <MessageAlert
        className={styles.alert}
        message={alert}
        variant="warning"
        isInitialised
      />
      <p className={styles.text}>{message}</p>
    </Modal.Content>
    <Modal.Footer />
  </Modal>
)
